import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { B300, B400, N30, N500 } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SelfMentionWrapper = styled.span({
	boxShadow: token('elevation.shadow.overlay', `0 0 0 0.5px ${B300}`),
	borderColor: 'transparent',
	backgroundColor: token('color.background.brand.bold', B400),
	borderRadius: '10px',
	padding: token('space.025', '2px'),
	color: token('color.text.inverse', 'white'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MentionWrapper = styled.span({
	borderColor: 'transparent',
	backgroundColor: token('color.background.neutral', N30),
	borderRadius: '10px',
	padding: token('space.025', '2px'),
	color: token('color.text', N500),
});

export const MentionComponent = ({ name, isUserSelf }) => {
	return isUserSelf ? (
		<SelfMentionWrapper>{name}</SelfMentionWrapper>
	) : (
		<MentionWrapper data-testid="mention-component">{name}</MentionWrapper>
	);
};
